export function apiValue<T = any>(
  res: any,
  key: string,
  fallback?: T
): T {
  if (res == null) {
    return fallback as T;
  }
  const value = res[key];
  return (value == null ? fallback : value) as T;
}

export class ApiResponse<T> {
	id?: any;
	image?: T;
	url?: T;
	urls?: T;
	token?: any;
	patient?: T;
	patients?: T;
	order?: T;
	orders?: T;
	orderId?: T;
	paidCount?: number[];
	unpaidCount?: number[];
	favoriteLine?: T;
	favoriteLines?: T;
	prescription?: T;
	prescriptions?: T;
	product?: T;
	products?: T;
	productHistory?: T;
	priceCheck?: T;
	store?: T;
	stores?: T;
	user?: T;
	users?: T;
	vendor?: T;
	vendors?: T;
	vendorOrder?: T;
	vendorOrders?: T;
	vendorOrderCounts?: T;
	vendorInventory?: T;
	lastInvoiceDates?: T;
	rents?: T;
	settings?: T;
	data?: T;
	message: string;
	success: boolean;
}
